import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';

import ubicacionService from '../../../service/logistica/ubicacionService';
import almacenService from '../../../service/administracion/almacenService';
import establecimientoService from '../../../service/administracion/establecimientoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            firstLoad: false,
            loadingNew: false,
            establecimientos: [],
            almacenes: [],
            estados: estadoMock.values,
            filter: {
                codigo: '',
                nombre: '',
                idEstablecimiento: 0,
                idAlmacen: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            codigo: '',
            nombre: '',
            idEstablecimiento: 0,
            idAlmacen: 0,
            almacenLoading: false,
            establecimientos: [],
            almacenes: []
        }
    };

    handleClearFilters = () => {
        var filter = {
            codigo: '',
            nombre: '',
            idEstablecimiento: 0,
            idAlmacen: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter, almacenes: [] });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = async (property, value) => {
        
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property === "idEstablecimiento") {
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen : undefined },
                almacenes: almacenes ? almacenes : []
            });
        }
    };

    handleChangeForm = async (property, value, form) => {
        
        if (property === "idEstablecimiento") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }
    }


    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await ubicacionService.eliminar(values);
            else
                response = await ubicacionService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = async () => {    
        
        this.setState({ loadingNew: true });  
        const establecimientos = !this.state.firstLoad ? await establecimientoService.principales() : this.state.establecimientos;
        // const almacenes = !this.state.firstLoad ? await almacenService.listar() : this.state.almacenes;
        this.setState({
            firstLoad: true,
            loadingNew: false,
            establecimientos: establecimientos ? establecimientos : [] 
        }, () => {
            var formValues = this.fetchEmptyFormValues();
            formValues.establecimientos = this.state.establecimientos;
            this.setState({
                visible: true, 
                formValues 
            });
        });
    };

    handleEdit = async (values) => {
        const establecimientos = !this.state.firstLoad ? await establecimientoService.principales() : this.state.establecimientos;
        this.setState({
            firstLoad: true,
            establecimientos: establecimientos ? establecimientos : [] 
        }, async () => {
            
            const response = await ubicacionService.obtenerPorId(values.id);
            const almacenes = await almacenService.listarPorIdEstablecimiento(response.idEstablecimiento);
            if (response !== undefined) {
                this.setState({
                    visible: true,
                    formValues: {
                        id: response.id,
                        codigo: response.codigo,
                        nombre: response.nombre,
                        idAlmacen: response.idAlmacen,
                        idEstablecimiento: response.idEstablecimiento,
                        establecimientos: this.state.establecimientos,
                        almacenes: almacenes ? almacenes : [] 
                    }
                });
            }
        });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await ubicacionService.registrar(values);
            else
                response = await ubicacionService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                form.setFieldsValue(empty);
                form.resetFields();
                this.setState({ visible: false, formValues: empty });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, ubicacionService.paginacion);
        const establecimientos = !this.state.firstLoad ? await establecimientoService.principales() : this.state.establecimientos;
        this.setState({ 
                establecimientos: establecimientos ? establecimientos : [] 
            });
    }

    render() {
        return (
            <div>
                <Header
                    title="Ubicación"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingNew}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    almacenes={this.state.almacenes}
                    establecimientos={this.state.establecimientos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onChange={this.handleChangeForm}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}